import { render } from "./SpeechPlay.vue?vue&type=template&id=755f22d3"
import script from "./SpeechPlay.vue?vue&type=script&lang=js"
export * from "./SpeechPlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__